import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button, Container, Row, Col, Form, Modal, Toast, TabPane, Stack } from 'react-bootstrap';
import { PowerBIEmbed } from 'powerbi-client-react';
import * as pbi from 'powerbi-client';

/** Servicios */
import tokenService from "../../services/token.service";

const TresdENPROBI = () => {
    const [token, setToken] = useState('');
    const [report, setReport] = useState('');

    async function getTokenB() {
        let t = await tokenService.getTokenB();
        console.log(t.data);
        setToken(t.data.accessToken);
    }

    return (
        <Container>
            <Row>
                <PowerBIEmbed
                    embedConfig={{
                        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                        id: '0bf22ee0-d96f-4357-8bd9-a1acf092d884',
                        embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=0bf22ee0-d96f-4357-8bd9-a1acf092d884&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVBBQVMtMS1TQ1VTLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwiYW5ndWxhck9ubHlSZXBvcnRFbWJlZCI6dHJ1ZSwiY2VydGlmaWVkVGVsZW1ldHJ5RW1iZWQiOnRydWUsInVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlLCJza2lwWm9uZVBhdGNoIjp0cnVlfX0%3d',
                        accessToken: token,//'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyIsImtpZCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvZTk0NDk3ZDEtMTYxZi00Y2U5LWE0ZDgtYzcxODA1ZDAyYTZiLyIsImlhdCI6MTYyMjU3NjU0OCwibmJmIjoxNjIyNTc2NTQ4LCJleHAiOjE2MjI1ODA0NDgsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVFFBeS84VEFBQUFLSHJ0ZW05TU5UaEJpK0RObnJmUWcvNWc0bnpqa2p1bGpOZGgvU1dvdTlaeVo1dDR5bHU5eWxwSDcyZms4NGtsIiwiYW1yIjpbInB3ZCJdLCJhcHBpZCI6ImU0MmY3ZmIxLWRkOWMtNGRhYi1hNDJhLTFlNjQ2YmI1YmE0ZCIsImFwcGlkYWNyIjoiMSIsImZhbWlseV9uYW1lIjoiTGFndWVzIiwiZ2l2ZW5fbmFtZSI6IlBhYmxvIiwiaXBhZGRyIjoiMTkwLjE1MS40My4xMTQiLCJuYW1lIjoiUGFibG8gTGFndWVzIiwib2lkIjoiNWM3MzFlZGQtYmM5ZS00OTI1LTlmNDQtMjY1ZjYyOTBkNjVlIiwicHVpZCI6IjEwMDMyMDAxMkMxRDkyNDAiLCJyaCI6IjAuQVh3QTBaZEU2UjhXNlV5azJNY1lCZEFxYTdGX0wtU2MzYXROcENvZVpHdTF1azE4QVBvLiIsInNjcCI6IkFwcC5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkV3JpdGUuQWxsIENvbnRlbnQuQ3JlYXRlIERhc2hib2FyZC5SZWFkLkFsbCBEYXNoYm9hcmQuUmVhZFdyaXRlLkFsbCBEYXRhZmxvdy5SZWFkLkFsbCBEYXRhZmxvdy5SZWFkV3JpdGUuQWxsIERhdGFzZXQuUmVhZC5BbGwgRGF0YXNldC5SZWFkV3JpdGUuQWxsIEdhdGV3YXkuUmVhZC5BbGwgR2F0ZXdheS5SZWFkV3JpdGUuQWxsIFJlcG9ydC5SZWFkLkFsbCBSZXBvcnQuUmVhZFdyaXRlLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkV3JpdGUuQWxsIFdvcmtzcGFjZS5SZWFkLkFsbCBXb3Jrc3BhY2UuUmVhZFdyaXRlLkFsbCIsInN1YiI6Ii10YjhWRmZVX25RODI3SndmelQwVWJOOXdhRUFlQS1laS00NXZ6Y3o0UGMiLCJ0aWQiOiJlOTQ0OTdkMS0xNjFmLTRjZTktYTRkOC1jNzE4MDVkMDJhNmIiLCJ1bmlxdWVfbmFtZSI6InBsYWd1ZXNAc2VydmljaW9zNGouY2wiLCJ1cG4iOiJwbGFndWVzQHNlcnZpY2lvczRqLmNsIiwidXRpIjoidnB1eXBmcm0xa3lsWDR5M0o4VkFCQSIsInZlciI6IjEuMCIsIndpZHMiOlsiNjJlOTAzOTQtNjlmNS00MjM3LTkxOTAtMDEyMTc3MTQ1ZTEwIiwiYTllYTg5OTYtMTIyZi00Yzc0LTk1MjAtOGVkY2QxOTI4MjZjIiwiYjc5ZmJmNGQtM2VmOS00Njg5LTgxNDMtNzZiMTk0ZTg1NTA5Il19.KqI6g-BfxOGTT2Y3eX5JynViYFYtlczOBX4P-C1LrjR8C0vJgdprYn9OVPtDu2AkLy8O5fPdTyYv65Yn-8m8nEVxJgRxWYOi8d6ckkc4bAPLZkcha0UreKnJVeUc2CCJ-eJT2z7yOtr49seTdJ7mn4BpeZ0jywCpbE5HV5eMdQZjN7kbmFG9jt90Xghv0fGr4vNgCIw79iy7-C6g4GEZvDi3rheboqTdZJViKJjPdPmapBaPfg28mzSWOh6C9XdrRvSwFIbcX6OmowJYfGVzZbNuzjKcok1DV9PBrZ0Qhe0shZcEDqaQSp3A2MvU-Eyax7mdAFDUmdLzsHp1BwpNDA',
                        tokenType: pbi.models.TokenType.Aad,
                        allowFullScreen: true,
                        pageName: "ReportSectionf4e55edc05acbbb7831c",//this.state.direccion,//"ReportSection796368f112623c7c2480",//"ReportSection7fb3bfeab3521003c946",//ReportSection796368f112623c7c2480
                        settings: {
                            panes: {
                                filters: {
                                    expanded: false,
                                    visible: false
                                },
                                pageNavigation: {
                                    visible: false
                                }
                            }
                        }
                    }}

                    getEmbeddedComponent={(embeddedReport) => {
                        getTokenB();
                        console.log(`Embedded object of type "${embeddedReport.embedtype}" received en reporte direccion`);
                        setReport(embeddedReport);
                        window.report = embeddedReport;
                    }}

                    eventHandlers={
                        new Map([
                            ['loaded', function () { console.log('Report loaded'); }],
                            ['rendered', function () { console.log('Report rendered'); }],
                            ['error', function (event) { console.log(event.detail); }]
                        ])
                    }

                    cssClassName={"Embed-container"}
                />
            </Row>
        </Container>
    )
}

export default TresdENPROBI;